import { Record } from 'immutable';

const StudentGeneralInfoRecord = Record({
  id: undefined,
  firstName: undefined,
  lastName: undefined,
  studentNumber: undefined,
  avatarUrl: undefined,
  gender: undefined,
  localName: undefined,
});

class StudentGeneralInfo extends StudentGeneralInfoRecord { }

export default StudentGeneralInfo;



// WEBPACK FOOTER //
// ./domain/StudentGeneralInfo/model.js